export const setIsMobile = (isMobile) => {
  return {
    type: "SET_IS_MOBILE",
    payload: isMobile,
  };
};
